// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1PermissionsCreateSchema = z.object({
  resource_permission: z.object({
    resource: z.coerce.string().min(1).describe("Resource name to set permissions for"),
    permissions: z.array(z.object({
      role_id: z.number().int().describe("Role ID to assign permissions to"),
      operations: z.array(z.coerce.string()).describe("List of operations to permit"),
    })),
  }),
});
